import { render, staticRenderFns } from "./UnloadNew.vue?vue&type=template&id=4ac85c54&scoped=true"
import script from "./UnloadNew.vue?vue&type=script&lang=js"
export * from "./UnloadNew.vue?vue&type=script&lang=js"
import style0 from "./UnloadNew.vue?vue&type=style&index=0&id=4ac85c54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac85c54",
  null
  
)

export default component.exports